import keycloak from '../helpers/keycloak';

let isKeycloakInitialized = false;

const initKeycloak = async (options) => {
  if (!isKeycloakInitialized) {
    const authenticated = await keycloak.init(options);
    isKeycloakInitialized = true;
    return authenticated;
  }
  return !!keycloak.token;
};

/**
 * Inicia el flujo de login de Keycloak.
 * Si ya hay sesión, devuelve el token.
 */
const login = async () => {
  try {
      return keycloak.login({ redirectUri: window.location.origin + '/' });
    

  } catch (err) {
    console.error('Error iniciando sesión en Keycloak:', err);
    throw err;
  }
};

/**
 * Cierra la sesión y redirige a la página de logout de Keycloak.
 */
const logout = () => {
  return keycloak.logout();
};

/**
 * Verifica y refresca el token si está por expirar.
 */
const verifyToken = async (storedToken, storedRefreshToken) => {
  try {
    const authenticated = await initKeycloak({
      token: storedToken,
      refreshToken: storedRefreshToken,
      onLoad: 'check-sso',
      pkceMethod: undefined
    });
    //console.log(authenticated)
    if (!authenticated) {
      throw new Error('Invalid token!');
    }
    const refreshed = await keycloak.updateToken(30).catch(() => false);
    //if (refreshed) console.log('Token actualizado');
    //console.log("La info de keycloak es: ", keycloak )
    return {
      email: keycloak.tokenParsed?.email,
      valid: !!keycloak.token,
      token: keycloak.token,
      refreshToken: keycloak.refreshToken,
      resourceAccess: keycloak.resourceAccess
    };
  } catch (err) {
    throw err;
  }
};

/**
 * Redirige a la pantalla de registro de Keycloak.
 * (Depende de que el "Self Registration" esté habilitado en el realm)
 */
const register = () => {
  return keycloak.register();
};

const AuthService = {
  login,
  logout,
  verifyToken,
  register,
};

export default AuthService;
